export function getCurrentSeason(): string {
  return import.meta.env.VITE_CURRENT_SEASON?.trim() ?? "";
}

function hasNonEmptySeason(value: unknown): boolean {
  return typeof value === "string" && value.trim().length > 0;
}

/** Fills `season` on match (and other season-aware) admin payloads when missing or empty. */
export function injectCurrentSeasonIfNeeded<T>(data: T): T {
  if (!data || typeof data !== "object" || Array.isArray(data)) {
    return data;
  }

  const season = getCurrentSeason();
  if (!season) {
    return data;
  }

  const record = data as Record<string, unknown>;
  const isMatchPayload = "teamOne" in record && "teamTwo" in record;
  const hasSeasonField = "season" in record;

  if (!isMatchPayload && !hasSeasonField) {
    return data;
  }

  if (hasNonEmptySeason(record.season)) {
    return data;
  }

  return { ...record, season } as T;
}
